import script from "./BaseCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseCard.vue?vue&type=script&setup=true&lang=js"

import "./BaseCard.vue?vue&type=style&index=0&id=3a5a6c2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a5a6c2a"]])

export default __exports__